import Cleave from 'cleave.js'

function getElem (el) {
  if (el.tagName.toLowerCase() !== 'input') {
    el = el.querySelector('input')
  }

  if (!el) {
    throw new Error('mask: invalid input')
  }

  return el
}

export default {
  mounted: (el, binding) => {
    el = getElem(el)

    el.cleave = new Cleave(el, binding.value || {})
  },
  updated: (el) => {
    el = getElem(el)

    const event = new Event('input', { bubbles: true })
    setTimeout(function () {
      el.value = el.cleave.properties.result
      el.dispatchEvent(event)
    }, 50)
  }
}
